import React,{useState} from 'react'
import Provinces from './Provinces'

const Pakistan = (props) => {
    const [isToggle, setIsToggle] = useState(false)

    return (
        <>
        <div className="pakistan">
            <div className="container">
                <div className="row">
                    <div className="col-md-8 mx-auto">
                        <div className='pakistan-inner'  onClick={()=> setIsToggle(!isToggle)}  >
                        <h1>{props.heading}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {isToggle &&     <Provinces heading="Provinces OF Pakistan"/>}
        </>
    )
}

export default Pakistan
